import {
  SEND_OTP_REQUEST,
  SEND_OTP_RESPONSE,
  GOOGLE_LOGIN_REQUEST,
  GOOGLE_LOGIN_RESPONSE,
  FACEBOOK_LOGIN_REQUEST,
  FACEBOOK_LOGIN_RESPONSE,
  MOBILE_NO_LOGIN_REQUEST,
  MOBILE_NO_LOGIN_RESPONSE,
  LOGOUT_REQUEST,
  LOGOUT_RESPONSE,
} from "./actionTypes";

export const sendOtpRequest = (data) => {
  return {
    type: SEND_OTP_REQUEST,
    payload: {
      data,
    },
  };
};

export const sendOtpResponse = (apiResponse, loginMobileNo = null) => {
  return {
    type: SEND_OTP_RESPONSE,
    payload: {
      apiResponse,
      loginMobileNo,
    },
  };
};

export const googleLoginRequest = (data) => {
  return {
    type: GOOGLE_LOGIN_REQUEST,
    payload: {
      data,
    },
  };
};

export const googleLoginResponse = (apiResponse) => {
  return {
    type: GOOGLE_LOGIN_RESPONSE,
    payload: {
      apiResponse,
    },
  };
};

export const facebookLoginRequest = (data) => {
  return {
    type: FACEBOOK_LOGIN_REQUEST,
    payload: {
      data,
    },
  };
};

export const facebookLoginResponse = (apiResponse) => {
  return {
    type: FACEBOOK_LOGIN_RESPONSE,
    payload: {
      apiResponse,
    },
  };
};

export const mobileNoLoginRequest = (data) => {
  return {
    type: MOBILE_NO_LOGIN_REQUEST,
    payload: {
      data,
    },
  };
};

export const mobileNoLoginResponse = (apiResponse) => {
  return {
    type: MOBILE_NO_LOGIN_RESPONSE,
    payload: {
      apiResponse,
    },
  };
};

export const logoutRequest = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};

export const logoutResponse = () => {
  return {
    type: LOGOUT_RESPONSE,
  };
};
